import { Outlet, NavLink } from 'react-router-dom'
import { Home, Wallet, Apple, Calendar, Bot, Settings, Menu } from 'lucide-react'
import { useState } from 'react'
import clsx from 'clsx'

const navItems = [
  { to: '/', icon: Home, label: 'Головна' },
  { to: '/finances', icon: Wallet, label: 'Фінанси' },
  { to: '/nutrition', icon: Apple, label: 'Харчування' },
  { to: '/plans', icon: Calendar, label: 'Плани' },
  { to: '/assistant', icon: Bot, label: 'AI асистент' },
  { to: '/settings', icon: Settings, label: 'Налаштування' },
]

export default function Layout() {
  const [sidebarOpen, setSidebarOpen] = useState(false)
  // const location = useLocation()

  return (
    <div className="flex min-h-screen bg-plnly-bg">
      {/* Sidebar - desktop */}
      <aside className="hidden md:flex w-56 flex-col border-r border-plnly-border bg-[#0D121F] p-4">
        <div className="flex items-center gap-2 mb-8 px-2">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-emerald-400 flex items-center justify-center text-white font-bold text-sm">
            P
          </div>
          <span className="font-semibold text-lg">Plnly</span>
        </div>

        <nav className="flex-1 space-y-1">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) =>
                clsx(
                  'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors',
                  isActive
                    ? 'bg-violet-600/20 text-violet-300'
                    : 'text-slate-400 hover:bg-slate-800/50 hover:text-white'
                )
              }
            >
              <item.icon size={18} />
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="mt-auto pt-4 border-t border-plnly-border">
          <div className="flex items-center gap-3 px-2">
            <div className="w-9 h-9 rounded-full bg-slate-700 flex items-center justify-center text-sm font-medium">
              В
            </div>
            <div>
              <div className="text-sm font-medium">Вадим</div>
              <div className="text-xs text-slate-500">Профіль</div>
            </div>
          </div>
        </div>
      </aside>

      {/* Mobile header */}
      <div className="flex-1 flex flex-col">
        <header className="md:hidden flex items-center justify-between px-4 py-3 border-b border-plnly-border">
          <button onClick={() => setSidebarOpen(true)} className="p-2 -ml-2">
            <Menu size={22} />
          </button>
          <div className="flex items-center gap-2">
            <div className="w-7 h-7 rounded-lg bg-gradient-to-br from-violet-500 to-emerald-400 flex items-center justify-center text-white font-bold text-xs">
              P
            </div>
            <span className="font-semibold">Plnly</span>
          </div>
          <div className="w-8" />
        </header>

        {/* Mobile sidebar overlay */}
        {sidebarOpen && (
          <div className="fixed inset-0 z-50 md:hidden">
            <div className="absolute inset-0 bg-black/60" onClick={() => setSidebarOpen(false)} />
            <aside className="absolute left-0 top-0 bottom-0 w-64 bg-[#0D121F] p-4 border-r border-plnly-border">
              <div className="flex items-center gap-2 mb-8 px-2">
                <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-violet-500 to-emerald-400 flex items-center justify-center text-white font-bold text-sm">
                  P
                </div>
                <span className="font-semibold text-lg">Plnly</span>
              </div>
              <nav className="space-y-1">
                {navItems.map((item) => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    end={item.to === '/'}
                    onClick={() => setSidebarOpen(false)}
                    className={({ isActive }) =>
                      clsx(
                        'flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-medium transition-colors',
                        isActive
                          ? 'bg-violet-600/20 text-violet-300'
                          : 'text-slate-400 hover:bg-slate-800/50 hover:text-white'
                      )
                    }
                  >
                    <item.icon size={18} />
                    {item.label}
                  </NavLink>
                ))}
              </nav>
            </aside>
          </div>
        )}

        <main className="flex-1 overflow-auto">
          <Outlet />
        </main>
      </div>
    </div>
  )
}
